import $ from 'jquery';

var buttonFrequency = $('.js--frequency'),
	buttonAmount    = $('.js--amount'),
	customAmount 	= $('.js--custom-amount'),
	buttonDonate    = $('.js--button-donate'),
	email 			= $('.js--email');
	
// Toggling frequency
buttonFrequency.on('click', function() {
	$('.js--frequency').removeClass('active');
	$(this).toggleClass('active');
});
// Toggling amount
buttonAmount.on('click', function() {
	$('.js--amount').removeClass('active');
	$('.js--custom-amount').val("")
	$(this).toggleClass('active');
});
// Resetting amounts and setting the custom-amount
customAmount.on('change', function() {
	$('.js--amount').removeClass('active');
});
	
buttonDonate.on( 'click', function(e) {
	e.preventDefault();
	var amountInput 	= customAmount.val(),
		amountButton 	= $('.js--amount.active').data('amount'),
		amount 			= amountInput != '' ? amountInput : amountButton,
		frequency  		= $('.js--frequency.active').data('frequency') == 'monthly' ? '&interval=' + $('.js--frequency.active').data('frequency') : '',
		email 			= $('.js--email').val() ? '&email=' + $('.js--email').val() : '',
		urlValue;

	urlValue = 'https://mhinternational.giv.sh/a11a?amount=' + amount + frequency + email;
	
	if ( $.trim(amountInput).match(/^\d+$/) || $.trim(amountButton).match(/^\d+$/) )
		window.location.replace(urlValue);
});
